module.exports = ".modal {\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000 !important;\n  overflow: scroll; }\n\n@media only screen and (min-width: 576px) {\n  .modal-dialog {\n    margin-top: 200px !important; } }\n\n.modal-footer {\n  border-top: none; }\n\n.modal-header {\n  background-color: #343a40;\n  color: white;\n  text-align: center;\n  border-bottom: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/modal-dialog/modal-dialog.component.scss
// module id = ./src/app/shared/components/modal-dialog/modal-dialog.component.scss
// module chunks = main